import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth'
import { Capacitor } from '@capacitor/core'

GoogleAuth.init()

// Init firebase
// !!! Update: consider saving settings as Environment Variables
// Note: The Firebase config object contains unique, but non-secret identifiers for your Firebase project.
const config = {
  apiKey: 'AIzaSyC2QaLhyb3pQBFYb4whceAVgt08nfLYzYY',
  authDomain: 'zambezefarmer.firebaseapp.com',
  databaseURL: 'https://zambezefarmer.firebaseio.com',
  projectId: 'zambezefarmer',
  storageBucket: 'zambezefarmer.appspot.com',
  messagingSenderId: '751821378156',
  appId: '1:751821378156:web:811e7e41c9a7d570f6fe49',
  measurementId: 'G-Y4TXQ0KF13'
}

firebase.initializeApp(config)

const auth = firebase.auth()
const db = firebase.firestore()
const storage = firebase.storage()

if (location.hostname === 'localhost' && Capacitor.getPlatform() === 'web') {
  auth.useEmulator('http://localhost:9099')
  db.useEmulator('localhost', 8088)
  storage.useEmulator('localhost', 9199)
}

const timestamp = firebase.firestore.FieldValue.serverTimestamp()
const FieldValue = firebase.firestore.FieldValue

db.enablePersistence({ synchronizeTabs: true }).catch((err) => {
  if (err.code === 'failed-precondition') {
    // Multiple tabs open, persistence can only be enabled
    // in one tab at a a time.
    // ...
  } else if (err.code === 'unimplemented') {
    // The current browser does not support all of the
    // features required to enable persistence
    // ...
  }
})
// Subsequent queries will use persistence, if it was enabled successfully

const localPersitence = firebase.auth.Auth.Persistence.LOCAL

export { firebase, db, auth, storage, localPersitence, FieldValue, timestamp }
